import { faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import donate from "../../assets/donation/donate.png";
import donation from "../../assets/donation/donation.png";

import inbox from "../../assets/donation/sending_messages.png";
import PaymentAccounts from "./../NoticeBoard/Payment/PaymentAccounts";

export default function Donation() {
  return (
    <div className="container mx-auto px-5 my-10">
      <section className="my-10">
        <p className="text-center text-2xl">স্বাগতম!</p>
      </section>

      {/* Descripttion  */}
      <section className="my-10">
        <p className="text-xl">
          আপনারা জানেন,
          {/* <span className="badge bg-pink-300">শুধুমাত্র মহিলাদের জন্য</span> */}
        </p>
        <p>
          আমরা সমাজের সর্বস্তরের মানুষের কাছে ইসলামের দাওয়াত পৌছে দিতে কাজ করে
          যাচ্ছি।
        </p>
        <p>
          আমাদের কোর্সগুলো সবার কাছে পৌছে দিতে, বিশেষভাবে অর্থনৈতিকভাবে
          অসচ্ছলদের কাছে ফ্রীতে পৌছে দিতে স্কলারশিপের ব্যবস্থা রেখেছি।
        </p>
        <p>
          এইজন্য আপনাদের সহযোগিতা প্রয়োজন। আপনাদের দান-সাদকার টাকায় আমরা
          অভাবীদেরকে ফ্রীতে পড়ার সুযোগ করে দিতে পারি।
        </p>
      </section>

      {/* Donation */}
      <section className="my-20">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="order-2">
            <p className="text-xl my-4">সদকা জারিয়ায় অংশগ্রহন করুন</p>
            <p>
              আপনার দান-সাদকার টাকায় অন্য কেউ দ্বীনি ইলম অর্জন করবে। ইনশাআল্লাহ
              এই টাকা আপনার জন্য সদকা জারিয়া হিসেবে আল্লাহ কবুল করবেন।
            </p>
            <p>
              আমাদের শিক্ষার্থী ভাই-বোনেরা নিজে শেখার পাশাপাশি অন্যদেরকে শেখান
              এবং দাওয়াতি কাজে অংশগ্রহন করেন। তাই আশা করা যায়, আপনি যদি এমন
              ভাই-বোনদেরকে দ্বীনি ইলম অর্জনে সহযোগিতা করেন, আপনার আমলনামায়ও ভালো
              কাজের সওয়াব যুক্ত হতে থাকবে, ইনশাআল্লাহ।
            </p>
            <br></br>
            <p>এমন সুযোগ কেন হাতছাড়া করবেন?</p>
          </div>
          <div className="order-1 md:order-3">
            <img className="rounded-lg block mx-auto my-10 " src={donation} />
          </div>
        </div>
      </section>

      {/* Amount  */}
      <section className="my-40">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <img className="mx-auto" src={donate} alt="" />
          </div>
          <div>
            <h3 className="text-xl text-blue-600 my-5">
              যেকোন পরিমান টাকা দান করুন
            </h3>
            <p>
              কোন এমাউন্ট ছোট নয়। আপনার দান করা যে কোন পরিমান টাকা আরেকজনকে
              দুশ্চিন্তা মুক্ত করবে।
            </p>
            <p>
              কোন একটি কোর্সের জন্য ১০/৫ জনের স্কলারশিপের ব্যবস্থা করতে পারেন।
              যেমনঃ আক্বিদা কোর্সের লেভেল ১ এর কোর্স ফী ১৫০০ টাকা। সেক্ষেত্রে ১০
              জনের জন্য ১০ * ১৫০০ = ১৫,০০০ টাকা দিতে পারেন।
            </p>
            <p>
              অথবা যে কোন এমাউন্ট পাঠাতে পারেন, যেমন ২০,০০০ টাকা , ১০,০০০ টাকা,
              ৫,০০০ টাকা ।
            </p>
          </div>
        </div>
      </section>

      {/* payment  */}
      <section className="mb-10" id="send-money">
        <div>
          <h2 className="text-2xl text-green-600">
            <FontAwesomeIcon className="pr-5" icon={faMoneyBillTransfer} />
            কিভাবে টাকা পাঠাবেন?
          </h2>
          <p className=" mt-3">
            নিচের যে কোন নাম্বারে টাকা পাঠান (
            <span className="text-red-500 font-bold"> Send Money </span>)
          </p>
          <p className="">
            <FontAwesomeIcon
              className="text-slate-500 me-1"
              icon={"fa-solid fa-copy"}
            />{" "}
            একাউন্ট নাম্বার কপি করতে নাম্বারের উপর ক্লিক করুন।
          </p>
          <p className="">
            <strong className="text-red-600">দোকান থেকে টাকা না পাঠিয়ে </strong>{" "}
            নিজের/বাড়ির কারো নাম্বার থেকে পাঠান, তাহলে টাকাটা গেল কিনা, ঠিক
            নাম্বারে গেল কিনা নিশ্চিত হতে পারবেন।{" "}
          </p>
          <p className="mt-1 mb-5">
            <FontAwesomeIcon className="text-blue-500" icon={"image"} /> সম্ভব
            হলে টাকা পাঠানোর পর{" "}
            <strong className="text-blue-600">
              স্ক্রিনশট/মানি রিসিটের ছবি
            </strong>{" "}
            তুলুন।{" "}
          </p>
          {/* <p className='mb-5'><FontAwesomeIcon className='text-red-500' icon={'ban'}/> টাকা পাঠানোর এই নাম্বারগুলোতে <strong className='text-red-600'>কল করবেন না</strong> । যে কোন প্রয়োজনে আমাদের সাথে <a target="_blank" href='https:m.me/alharamain.ac' className='bg-sky-300 px-1 rounded-sm'>মেসেঞ্জারে</a>/<a target="_blank" href='https:wa.me/+966578621278' className='bg-lime-400 px-1 rounded-sm'>হোয়াটসঅ্যাপে</a>/<a target="_blank" href='https:t.me/+966578621278' className='bg-blue-400 px-1 rounded-sm'>টেলিগ্রামে</a> যোগাযোগ করুন।</p> */}

          <PaymentAccounts />
        </div>
      </section>

      {/* imbox  */}
      <section className="my-20">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center">
          <div className="order-2 mx-auto">
            <p className="text-xl my-4 text-orange-600">
              আমাদের সাথে যোগাযোগ করুন
            </p>
            <p>অনুগ্রহ করে টাকা পাঠানোর পর আমাদেরকে ইনবক্সে মেসেজ দিন।</p>
            <p>কোন কোর্সের জন্য, কতো টাকা দিতে চান, আমাদেরকে জানান।</p>
            <br></br>
            <p>সম্ভব হলে টাকা পাঠানোর স্ক্রিনশট দিন।</p>
          </div>
          <div className="order-1 md:order-3">
            <img className="rounded-lg block mx-auto my-10 " src={inbox} />
          </div>
        </div>
      </section>
    </div>
  );
}
